import { PubSub, FeatureDetection } from "../utils";

// TODO: Add unit tests

type HeaderOptionsT = {
  minOpacity: number,
  maxOpacity: number
}

const _config: HeaderOptionsT = {
  minOpacity: .8,
  maxOpacity: 1
}

let $el: object

/**
 * Given an id will initialize the module interactions
 * @param {string} id
 */
const init = (): void => {
  $el = document.querySelector(`#PsHeader`)

  if ($el == null) return

  addEventListeners()
  setOpacity()
}

/**
 * Translates scroll tick count to binary range 
 * @param {number} ticks
 * @returns {number} Binary range
 */
const scrollTicksToBinaryRange: number = ticks => ticks * 0.001 * 2

/**
 * Limits a binary range to the given min/max limits
 * @param {number} min
 * @param {number} max
 * @returns {number} Opacity value
 */
const getLimitedOpacity: number = (min: number = 0, max: number = 1) => {
  let opacityUnit = scrollTicksToBinaryRange(window.pageYOffset) + min
  if (opacityUnit >= max) opacityUnit = max
  if (opacityUnit <= min) opacityUnit = min
  return opacityUnit;
}

const getBGcolor = (opacity = 1) => {
  // #191613 === rgb(25,22,19)
  return `rgba(25, 22, 29, ${opacity})`;
}

/**
 * Sets the inline style of the given element to have a dynamic background colour based on user scroll position
 */
const setOpacity = (): void => {
  const opacity = getLimitedOpacity(_config.minOpacity, _config.maxOpacity).toFixed(2)
  $el.style.backgroundColor = getBGcolor(opacity)
}


/**
 * Sets the inline style of the given element to full opacity
 */
const setFullOpacity = (): void => {
  $el.style.backgroundColor = getBGcolor()
}

/**
 * Bind DOM Event handlers
 */
const addEventListeners = (): void => {
  window.addEventListener('scroll', setOpacity)

  PubSub.subscribe('header:scroll', setOpacity)
  PubSub.subscribe('header:active', setFullOpacity)
}

const Header = { init }
export default Header



// WEBPACK FOOTER //
// ./js/core/Header.js